import firestore from "@/firebase/firestore";

export const storeObservation = (data, isNew) => {
  const observation = JSON.parse(JSON.stringify(data));
  observation.updated_at = new Date();
  if (isNew) {
    observation.created_at = new Date();
    return firestore
      .collection("users")
      .doc(observation.customer_id)
      .collection("observations")
      .add(observation);
  } else {
    return firestore
      .collection("users")
      .doc(observation.customer_id)
      .collection("observations")
      .doc(observation.id)
      .update({
        description: observation.description,
        updated_at: observation.updated_at,
      });
  }
};

export const deleteObservation = (user_id, id) => {
  return firestore
    .collection("users")
    .doc(user_id)
    .collection("observations")
    .doc(id)
    .delete();
};
